export const FIELD_MAIN_CHARGES = 'mainCharges';
export const UI_REPORT_NAME_PAYROLL_CHARGES = 'payrollCharges';
